import React from 'react'
import './Navbar.css';
import Toggle from '../Toggle/Toggle';
import {Link} from 'react-scroll';

export default function Navbar() {
  return (
    <div className="n-wrapper">
        <div className="n-left">
          <div className="n-name">Vishal</div> 
          <Toggle/>
        </div>
        <div className="n-right">
          <div className="n-list">
            <ul>
                <li><Link  to="active" spy={true} smooth={true}>
                  Home
                  </Link></li>
                <li><Link to="services" spy={true} smooth={true}>
                  Serivces</Link></li>
                <li><Link to="experienc" spy={true} smooth={true}>
                  Experience</Link></li>
                <li>Portfolio</li>
                <li>Testimonial</li>
            </ul>
            </div>
            <Link to="contact" spy={true} smooth={true}>
            <button className='buttone'>Contact</button>
            </Link>
        </div>
    </div>
  )
}
